import * as Sentry from "@sentry/react-native";
import {
  all,
  call,
  delay,
  select,
  take,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import {
  navigate,
  navigationRef,
  previousScreens,
  routeNameRef,
} from "@navigation";
import {
  APPLINK_CONFIGURED,
  HANDLE_APPLINK,
  HANDLE_DEEP_LINK,
  HANDLE_DEEP_LINK_NAVIGATION,
} from "@reducers/actionTypes";

import { getData, setData } from "@lib/storage";
import handleDeepLink from "./handleDeepLink";
import handleDeepLinkNavigation from "./handleDeepLinkNavigation";

const REFERER_NAVIGATED = "REFERER_NAVIGATED";

function* deepLinkNavigate(nav_screen, params, forceNavigate) {
  try {
    yield delay(1);
    try {
      let count = 0;
      let countMax = 10;
      let navigationSuccess = false;
      while (count < countMax) {
        count += 1;
        if (forceNavigate) {
          navigate(nav_screen, params);
        } else if (!previousScreens.current?.includes(nav_screen)) {
          navigate(nav_screen, params);
        }
        yield delay(10);
        if (
          routeNameRef.current === nav_screen ||
          navigationRef.current?.getCurrentRoute() === nav_screen ||
          previousScreens.current?.includes(nav_screen)
        ) {
          navigationSuccess = true;
        }
        if (navigationSuccess) {
          yield call(setData, REFERER_NAVIGATED, true);
          const hashResult = yield select((s) => s.deepLink?.hashResult);
          if (hashResult) {
            hashResult.nav_screen = null;
          }

          break;
        } else {
          yield delay(100);
        }
      }
    } catch (e) {
      console.log(e);
    }
  } catch (e) {
    Sentry.captureException(e);
  }
}
function* handleAppLink(action) {
  const { payload } = action || {};
  const { forceNavigate } = payload || {};
  const applinkConfigured = yield select((s) => s.deepLink?.APPLINK_CONFIGURED);
  if (!applinkConfigured) {
    yield take(APPLINK_CONFIGURED);
  }

  const keys = yield select((s) => ({
    userToken: s.auth?.userToken,
    userName: s.auth?.user?.name,
    userPincode: s.auth?.user?.pincode,
  }));

  const isUserOnHomepage = Object.values(keys).every((key) => !!key);

  const { hashResult, referer } = yield select((s) => s.deepLink);

  if (!isUserOnHomepage) {
    return;
  }

  const refererNavigated = yield call(getData, REFERER_NAVIGATED);

  let { nav_screen, nav_params } = hashResult || {};

  if (!refererNavigated) {
    nav_screen = nav_screen || referer?.hashResult?.nav_screen;
    nav_params = nav_params || referer?.hashResult?.nav_params;
  }

  if (nav_screen) {
    let refererQueryParams = {};
    if (!refererNavigated) {
      refererQueryParams = referer?.installReferrer;
    }
    nav_params = {
      ...nav_params,
      ...hashResult?.searchParams,
      ...refererQueryParams,
    };

    yield call(deepLinkNavigate, nav_screen, nav_params, forceNavigate);
  }
}

export default function* () {
  yield all([
    takeLatest(HANDLE_DEEP_LINK, handleDeepLink),
    takeLatest(HANDLE_DEEP_LINK_NAVIGATION, handleDeepLinkNavigation),
    takeEvery(HANDLE_APPLINK, handleAppLink),
  ]);
}
